import { render, staticRenderFns } from "./device.vue?vue&type=template&id=24aa49b5&scoped=true"
import script from "./device.ts?vue&type=script&lang=ts&external"
export * from "./device.ts?vue&type=script&lang=ts&external"
import style0 from "./device.scoped.scss?vue&type=style&index=0&id=24aa49b5&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24aa49b5",
  null
  
)

export default component.exports